module.exports = __webpack_public_path__ + "img/teeth-16.4a812664.png";